export const encryptionKey={
    key: "/XGU0BVsWKXcXGA5JW6nts542iyX97g2/kzxdW7uJig="
  }
  